import { apiGetAuth, apiPutAuth } from '@/utils/api'
import { API_INVOICE } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  payment_confirmation_list: { 
    isLoading: false, 
    data: false
  },
  detail_payment_confirmation: {
    isLoading: false,
    data: false
  },
  data_modal_add_edit: {},
  detail_modal_preview: {},
  payment_confirmation_setting: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false,
    modalSummary: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  }
}

const mutations = {
  "SET_PAYMENT_CONFIRMATION_LIST": (state, payload) => {
    state.payment_confirmation_list = payload
  },
  "SET_DETAIL_PAYMENT_CONFIRMATION": (state, payload) => {
    state.detail_payment_confirmation = payload
  },
  "SET_DETAIL_MODAL_PREVIEW": (state, payload) => {
    state.detail_modal_preview = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_PAYMENT_CONFIRMATION_SETTING": (state, payload) => {
    state.payment_confirmation_setting = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getPaymentConfirmationList(context, payload) {
    try {
      context.commit('SET_PAYMENT_CONFIRMATION_LIST', { isLoading: true })
      const response = await apiGetAuth(API_INVOICE.LIST, payload)
      context.commit('SET_PAYMENT_CONFIRMATION_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_PAYMENT_CONFIRMATION_LIST', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async getDetailPaymentConfirmation(context, payload) {
    try {
      context.commit('SET_DETAIL_PAYMENT_CONFIRMATION', { isLoading: true })
      const response = await apiGetAuth(API_INVOICE.BY_ID(payload))
      context.commit('SET_DETAIL_PAYMENT_CONFIRMATION', {
        isLoading: false,
        data: response.data.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_PAYMENT_CONFIRMATION', {
        isLoading: false,
        data: false
      })
      notificationDanger(error)
    }
  },
  async updatePaymentConfirmation (context, payload) {
    try {
      const response = await apiPutAuth(API_INVOICE.BY_ID(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  get_payment_confirmation_list: state => {
    return state.payment_confirmation_list
  },
  get_detail_payment_confirmation: state => {
    return state.detail_payment_confirmation
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_payment_confirmation_setting: state => {
    return state.payment_confirmation_setting
  },
  get_detail_modal_preview: state => {
    return state.detail_modal_preview
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
